<div class="parent">
  <div class="cet-loan-card-container l2-lci">
    <span style="color: #646464; padding-inline: 1rem"
      ><strong>{{ "LoanCard.FinanceAmount" | translate }}</strong></span
    >
    <p
      style="font-size: 20px; margin-top: 5px; padding-inline: 1rem"
      class="d-flex justify-content-between mt-3 mb-5"
    >
      <strong
        ><span class="Saudi_Riyal" style="font-size: 12px">
          {{ "Currency.SAR" | translate }}
        </span>
        {{ offer?.OfferAmt | currencyFormat }}
      </strong>
    </p>

    <div class="tenure-contianer">
      <div class="tenure">
        <p>
          <strong>{{ "OfferPage.Tenure" | translate }}</strong>
        </p>
        <p>
          <strong>{{ offer?.Tenure }} {{ "TimeUnits.Mon" | translate }}</strong>
        </p>
      </div>
      <div class="installment">
        <p>
          <strong>{{ "OfferPage.Installment" | translate }}</strong>
        </p>
        <p>
          <small class="Saudi_Riyal">{{ "Currency.SAR" | translate }} </small>
		  <strong>{{ offer?.InstallmentAmount | currencyFormat}}</strong>
        </p>
      </div>
    </div>
    <div class="profit-rate-container">
      <div class="rate">
        <strong>{{ "OfferPage.ProfitRate" | translate }} </strong>
        <strong>{{ offer?.ProfitRate }}%</strong>
      </div>
      <div class="annual-rate">
        <strong>{{ "OfferPage.APR" | translate }}</strong>
        <strong>{{ offer?.APR }}%</strong>
      </div>
    </div>
  </div>
</div>
